export { default } from './ProductNutritionalValues';
